import { useEffect, useState } from "react";
import { useAuthStore } from "../../store/useAuthStore";
import { useErrorStore } from "../../store/useErrorStore";

import { Get } from "../../http/httpVerbs";

import { Box } from "@mui/material";
import { Loader } from "../ui/Loader";
import { ButtonFL } from "../ui/ButtonFL";
import { FavelaOnboardingPopup } from "../FavelaOnboardingPopup";
import { CampanhasLines } from "./CampanhasLines";

import "./campanhas.css";
import { returnEnvironment } from "../../utils";

const useCampanhas = (creatorId) => {
    const [campanhas, setCampanhas] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const showError = useErrorStore((state) => state.showError);

    useEffect(() => {
        const fetchCampanhas = async () => {
            setIsLoading(true);

            try {
                const dataCampanhas = await Get(
                    `${process.env.REACT_APP_API_URL}/campanhas/?creator=${creatorId}&noFilter=true`,
                );
                setCampanhas(dataCampanhas);
            } catch (error) {
                showError(error);
            } finally {
                setIsLoading(false);
            }
        };

        if (creatorId) fetchCampanhas();
    }, [creatorId, showError]);

    return { campanhas, isLoading };
};

const isFavela = returnEnvironment() === "favela";

export const Campanhas = () => {
    const creator = useAuthStore((state) => state.creator);
    const { campanhas, isLoading } = useCampanhas(creator?.id);

    if (isLoading) return <Loader />;

    const hasCampanhas = campanhas && campanhas.length > 0;

    if (!hasCampanhas && isFavela) {
        return (
            <Box p={2} textAlign="center" mx='auto'>
                <h2>Nenhuma campanha encontrada</h2>
                <p>Você ainda não tem campanhas ativas.</p>
                <p>Aproveite para terminar de preencher seus dados.</p>
                <Box
                    sx={{
                        width: { xs: '100%', md: 700 },
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        mx: 'auto',
                    }}
                >
                    <ButtonFL
                        textKey="completeYourRegistration"
                        keyPrefix="signUp"
                        component="Link"
                        to={'/editUserInfo'}
                    />
                </Box>
                <FavelaOnboardingPopup />
            </Box>
        );
    }

    return <CampanhasLines campanhas={campanhas} creator={creator} />;
};
